import { CognitoResponse } from '@core/interfaces';

const CODE = 'ExpiredPasswordSoon';

export class ExpiredPasswordSoonError extends Error {
  constructor(response: CognitoResponse) {
    super(CODE);
    this['error'] = {
      code: CODE,
      response
     };
  }
}
